import { styled } from 'goober';
import { useEffect } from 'react';
import { useAtomValue } from 'jotai';

import { Navbar } from '../../features/navbar/navbar';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import 'tippy.js/dist/tippy.css';
import { Modals } from '../../modals';
import { Outlet } from 'react-router-dom';
import { PageLayout } from '../../page-layout';
import { isLoggingOutState } from '@/auth/auth.state';
import { useAuthorization } from '@/auth/hooks/use-authorization';
import { TemplatesSidebar } from '@/features/templates-sidebar/templates-sidebar';
import { RouteChangeRecorder } from '@/lib/mixpanel/route-change-recorder';
import { useMixpanelAuthenticatedUser } from '@/lib/mixpanel/use-mixpanel-authenticated-user';
import { AppToastContainer } from '@/ui/snackbar/app-toast-container';
import { useCurrentUserAuthErrorRedirect } from '@/user/use-current-user-auth-error-redirect';

import { useAppRedirect } from '../hooks/use-app-redirect';

export const ProtectedAppLayout = ({
  withTopbar = true,
}: {
  withTopbar?: boolean;
}) => {
  const { isUserAuthorized } = useAuthorization();
  const isLoggingOut = useAtomValue(isLoggingOutState);
  const { redirectToLogin } = useAppRedirect();
  const isFullHeightPage = !withTopbar;

  useMixpanelAuthenticatedUser();
  useCurrentUserAuthErrorRedirect();

  useEffect(() => {
    if (!isUserAuthorized && !isLoggingOut) {
      redirectToLogin();
    }
  }, [isLoggingOut, isUserAuthorized, redirectToLogin]);

  if (!isUserAuthorized) {
    return null;
  }

  return (
    <LayoutContainer>
      <RouteChangeRecorder />
      <Navbar />
      <MainLayoutWrapper>
        <Layout withTopbar={withTopbar} isFullHeightPage={isFullHeightPage}>
          <Outlet />
        </Layout>

        <AppToastContainer />
        <Modals />
      </MainLayoutWrapper>
      <TemplatesSidebar />
    </LayoutContainer>
  );
};

const Layout = styled(PageLayout)<{ isFullHeightPage?: boolean }>`
  ${({ isFullHeightPage }) => isFullHeightPage && 'overflow-y: hidden;'}
`;

const LayoutContainer = styled('div')`
  display: flex;
`;

const MainLayoutWrapper = styled('div')`
  flex-grow: 1;
`;
